import { Link } from 'react-router-dom'
import { ArrowBack } from '@mui/icons-material'
import { Container, IconButton, Typography } from '@mui/material'
import { routes } from '@/router'
import { usePlatform } from '@/hooks'

interface PageHeaderProps {
  children: React.ReactNode
  rollbackRoute?: string
}

export function PageHeaderContainer({
  children,
}: {
  children: React.ReactNode
}) {
  const { isAndroid } = usePlatform()
  return (
    <Container
      maxWidth="md"
      sx={{
        position: { xs: 'fixed', md: 'sticky' },
        top: 0,
        left: 0,
        zIndex: 1100,
        py: { xs: 2, md: 4 },
        px: { xs: 2, md: '0 !important' },
        pt: isAndroid ? 6 : 2,
      }}
    >
      {children}
    </Container>
  )
}

export function PageHeader({ children, rollbackRoute }: PageHeaderProps) {
  return (
    <PageHeaderContainer>
      <Typography variant="h4" textAlign="center" position="relative">
        <IconButton
          component={Link}
          to={rollbackRoute || routes.dashboard}
          color="primary"
          sx={{ position: 'absolute', left: 0, mt: -1 }}
        >
          <ArrowBack />
        </IconButton>

        {children}
      </Typography>
    </PageHeaderContainer>
  )
}
